<button
    (click)="openCloseStatusList($event)"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [ngClass]="{
        opened: isOverlayGroupsOpen(),
        notListed: !hasAnyOptions()
    }"
    class="status-indicator-btn resetStyles"
>
    <lib-status-indicator
        [iconName]="currentIcon()"
        [text]="currentText()"
        [colorType]="currentColorType()"
    ></lib-status-indicator>

    @if (hasAnyOptions()) {
        <span class="toggle-arrow" aria-hidden="true" [innerHTML]="toggleArrowIcon()"></span>
    }
</button>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOverlayGroupsOpen()"
    (detach)="isOverlayGroupsOpen.set(false)"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-custom-backdrop'"
    [cdkConnectedOverlayPush]="true"
    (backdropClick)="isOverlayGroupsOpen.set(false)"
>
    <div class="content" [ngClass]="{ show: isOverlayGroupsOpen() }" [style.min-width.px]="overlayMinWidth() || null">
        <div class="content-body">
            @if (config().hasLinkedBid && config().availableStatus.length > 0) {
                <app-opportunity-bid-status-menu [config]="config()" (statusSelected)="onBidStatusSelected($event)" />
            } @else {
                <app-opportunity-status-actions-menu
                    [config]="config()"
                    (disqualifyToggleClick)="onDisqualifyToggleClick()"
                    (manualStatusClick)="onManualStatusClick()"
                />
            }
        </div>
    </div>
</ng-template>
